import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-allowed',
  templateUrl: './not-allowed.component.html',
  styleUrls: ['./not-allowed.component.scss'],
  standalone: false
})
export class NotAllowedComponent implements OnInit {

  loading = false;

  constructor() { }

  ngOnInit(): void {
  }

}
